  $(document).ready(function() {
    var loading = false;

    function applyFadeEffect() {
      $('.main-blog').addClass('fade');
    }

    $(window).scroll(function() {
      var totalPages = parseInt($('[data-total-pages]').val());
      var currentPage = parseInt($('[data-current-page]').val());

      // return if ls-stop-load class exist
      if ( document.getElementById('blog-posts').classList.contains('ls-stop-load') || loading || currentPage >= totalPages) return;

      if ($(window).scrollTop() + $(window).height() > $(document).height() - 1100) { 
        loading = true;
        var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + (currentPage + 1));
        $('[data-current-page]').val(currentPage + 1);

        $.ajax({
          url: nextUrl,
          type: 'GET',
          dataType: 'html',
          success: function(responseHTML) {
            setTimeout(() => {
              var newPosts = $(responseHTML).find('.grid--view-items').children();
         
              $('.grid--view-items').append(newPosts);
              
              if (currentPage + 1 >= totalPages) {
                  $('.main-blog').removeClass('fade');
              }
              if (currentPage >= 1) {
                if( $('.grid--view-items .main_blog_full').hasClass('only_one') ){
                  $('.grid--view-items .main_blog_full').slice(2).each(function() {
                    $(this).removeClass('main_blog_full').addClass('main_blog_half');
                  });
                } else {
                  $('.grid--view-items .main_blog_full').slice(1).each(function() {
                    $(this).removeClass('main_blog_full').addClass('main_blog_half');
                  });
                }
              }
            }, 800);
          },
          complete: function() {
            loading = false;
          }
        });
      }
    });

    applyFadeEffect();
  });